module.exports = __webpack_public_path__ + "img/Annotated_Fey_Court_Map.9526993c.png";